import { useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Portfolio from "@/components/site/Portfolio";
import Products from "@/components/site/Products";
import AISection from "@/components/site/AISection";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/ChatWidget";

export default function Home() {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <div className="surface-page min-h-screen" data-testid="home-page">
      <Navbar />
      <Hero onOpenChat={() => setChatOpen(true)} />
      <About />
      <Portfolio />
      <Products />
      <AISection onOpenChat={() => setChatOpen(true)} />
      <Contact />
      <Footer />
      <ChatWidget open={chatOpen} setOpen={setChatOpen} />
    </div>
  );
}
